export default __webpack_public_path__ + "img/component-btn-pink.756a0979.png";